import { render } from "./permissionSettingUser.vue?vue&type=template&id=0b7feca5&scoped=true"
import script from "./permissionSettingUser.vue?vue&type=script&lang=js"
export * from "./permissionSettingUser.vue?vue&type=script&lang=js"

import "./permissionSettingUser.vue?vue&type=style&index=0&id=0b7feca5&scoped=true&lang=css"

import exportComponent from "D:\\A_Projcets_Code\\mes-chunyu\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b7feca5"]])

export default __exports__